export default __webpack_public_path__ + "static/media/pack-basic.6e113b98.png";